import { memo, type ReactNode } from 'react';

export type SimilarToAssetChipProps = {
  children: ReactNode;
  'data-testid': string;
  image: ReactNode;
};

export const SimilarToAssetChip = memo(({ children, 'data-testid': testId, image }: SimilarToAssetChipProps) => (
  <div
    className="pointer-events-none flex h-full ui2026:h-6 min-w-0 items-center overflow-hidden rounded-6 ads:bg-subtle bg-gray-3 ui2026:py-0.5 pr-1.5 ui2026:pl-0.5 font-medium ads:text-primary text-12 text-gray-12"
    data-testid={testId}
  >
    <div
      className="aspect-square ui2026:aspect-auto ui2026:size-5 h-full shrink-0 overflow-hidden ui2026:rounded-4"
      data-testid="SIMILAR_TO_ASSET_THUMBNAIL"
    >
      {image}
    </div>
    <span className="min-w-0 truncate pl-1.5">{children}</span>
  </div>
));

SimilarToAssetChip.displayName = 'SimilarToAssetChip';
